/*!
 * Copyright © 2020-2022. Verizon Connect Ireland Limited. All rights reserved.
 */

import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  input,
  OnChanges,
  Output,
  SimpleChanges
} from '@angular/core';
import { DeviceHealthIssueCategories, EPlotType, IAssetPlot } from '../../../core/models';
import { IDeviceHealth } from '../../../core/store/state';
import { IVehicleStatusInfo } from '../../models';

@Component({
  selector: 'fm-asset-status-item',
  templateUrl: './asset-status-item.component.html',
  styleUrls: ['./asset-status-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssetStatusItemComponent implements OnChanges {
  @Input()
  asset: IAssetPlot;
  @Input()
  isHighlighted: boolean;
  @Input()
  isSelected: boolean;
  @Input()
  vehicleStatusInfo: IVehicleStatusInfo;
  @Input()
  vehicleHealthStatus: IDeviceHealth;

  showSkeleton = input(false);

  @Output()
  contextMenuClicked = new EventEmitter<MouseEvent>();

  @HostBinding('class.vehicle-status--highlighted')
  get highlight() {
    return this.isHighlighted;
  }

  @HostBinding('class.selected')
  get selected(): boolean {
    return this.isSelected;
  }

  @HostBinding('class.asset-address-ready')
  assetAddressReady = false;

  @HostBinding('class.critical-health')
  get criticalHealth(): boolean {
    return this.vehicleStatusInfo?.showHealthStatus && this.checkVehicleHealthIssue() && !this.showSkeleton();
  }

  @HostBinding('style.pointer-events')
  get pointerEvents(): string {
    return this.showSkeleton() ? 'none' : null;
  }
  constructor() {}

  EPlotType = EPlotType;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['asset']) {
      this._isAssetAddressReady();
    }
  }

  public openVehicleContextMenuClick($event: MouseEvent): void {
    this.contextMenuClicked.emit($event);
  }

  public checkVehicleHealthIssue(): boolean {
    if (this.vehicleHealthStatus) {
      return DeviceHealthIssueCategories.findIndex(x => x === this.vehicleHealthStatus?.healthStatus.toUpperCase()) > -1;
    }
    return false;
  }

  private _isAssetAddressReady() {
    this.assetAddressReady = this.asset.address && this.asset.address.length > 0;
  }
}
